import type { IconData } from '@stacksjs/iconify-core'

export const arrowUpRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.828 2.414H2.243a1 1 0 1 1 0-2h8a.997.997 0 0 1 1 1v8a1 1 0 0 1-2 0V3.828l-6.779 6.779A1 1 0 0 1 1.05 9.192z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowUpRight
